const AemPortalService = function AemPortalService($rootScope, restangular, productGroupService, RREventFactory, $q, rrPlaceHolderCache, savedListsService, shopperService, currentUserService, bwsNotificationService, trolleyService, shopPageStateService, decorateAdditionalDetails, $uibModal) {
    this.$rootScope = $rootScope;
    this.restangular = restangular;
    this.productGroupService = productGroupService;
    this.RREventFactory = RREventFactory;
    this.$q = $q;
    this.rrPlaceHolderCache = rrPlaceHolderCache;
    this.savedListsService = savedListsService;
    this.shopperService = shopperService;
    this.currentUserService = currentUserService;
    this.bwsNotificationService = bwsNotificationService;
    this.trolleyService = trolleyService;
    this.shopPageStateService = shopPageStateService;
    this.decorateAdditionalDetails = decorateAdditionalDetails;
    this.$uibModal = $uibModal;
};

AemPortalService.prototype.makeScript = function (name, src) {
    const scriptsId = 'aemscripts';
    let aemScriptsContainer = document.getElementById(scriptsId);
    if (!aemScriptsContainer) {
        aemScriptsContainer = document.createElement('div');
        aemScriptsContainer.setAttribute('id', scriptsId);
        aemScriptsContainer.setAttribute('aem-script', 'true');
    }


    document.body.appendChild(aemScriptsContainer);
    const script = document.createElement('script');
    script.setAttribute('id', name);
    script.setAttribute('src', src);
    script.setAttribute('type', 'text/javascript');
    script.setAttribute('aem-script', 'true');
    aemScriptsContainer.appendChild(script);
};

function publishEvent (name, callback) {
    window.aemListener = window.aemListener || {};
    if (!window.aemListener[name]) {
        window.aemListener[name] = callback;
    }
}

AemPortalService.prototype.init = function (scope) {


    let trolleyListeners = [];

    publishEvent('getProductsBySku', (stockCodes) => {
        return this.restangular.one('Products/Bundles/', stockCodes).get().then(items => {
            return !!items && Array.isArray(items) ? items.filter(item => item && typeof item === 'object' && item.Products) : [];
        });
    });

    publishEvent('getProductGroup', (productGroupName, pageNumber, pageSize, sort, showOnlyAvailable) => {
        return this.productGroupService.selectProductGroup(productGroupName).then(group => {
            return this.productGroupService.getProducts({
                pageNumber,
                pageSize,
                sortType: sort,
                showOnlyAvailable
            }, group);
        });
    });

    publishEvent('updateCartAddListerner', (listener) => {
        trolleyListeners.push(listener);
    });

    publishEvent('updateCartRemoveListerners', () => {
        trolleyListeners = [];
    });

    publishEvent('getRichRelevanceEvents', (placement) => {
        const deferred = this.$q.defer();
        this.$rootScope.$on('RR:completed', () => {
            deferred.resolve(this.rrPlaceHolderCache[placement]);
        });
        return deferred.promise;
    });

    publishEvent('initRichRelevanceEvents', (eventName, placements, categoryId) => {
        const deferred = this.$q.defer();
        const urlSegments = window.location.pathname.split('/');
        let urlName = '';
        if (urlSegments[1] !== 'web' && urlSegments[1]) {
            urlName = urlSegments[1];
        } else if (urlSegments[2]) {
            urlName = urlSegments[2];
        }
        const data = { id: categoryId, name: urlName[0].toUpperCase() + urlName.slice(1).toLowerCase(), item: [] };
        this.RREventFactory.send({
            type: eventName,
            data
        }, placements);
        deferred.resolve();
        return deferred.promise;
    });

    publishEvent('addToWatchList', (stockcode, quantity, product) => {
        this.savedListsService.addToList(stockcode, quantity, product).then(() => {
            product.IsWatched = true;
            this.$rootScope.$emit('watchlist:updated');
            this.shopperService.currentUser.numberOfItemsInWatchList++;
        }, () => {
            this.$timeout(() => {
                if (this.currentUserService.currentUser.isGuest) {
                    this.bwsNotificationService.info('You need to login or register to add to your favourites');
                }
            }, 2000);
        });
    });

    publishEvent('removeFromWatchList', (stockcode, product) => {
        this.savedListsService.removeFromWatchList(stockcode).then(() => {
            product.IsWatched = false;
            this.$rootScope.$emit('watchlist:updated');
            this.shopperService.currentUser.numberOfItemsInWatchList--;
        });
    });

    publishEvent('openCartPanel', () => {
        this.shopPageStateService.triggerPanel('right', true, 'product tile overlay');
    });

    publishEvent('updateCart', (product, eventData) => {
        if (eventData && eventData.crossSellType && this.trolleyService.$stateParams) {
            this.trolleyService.$stateParams.crossSellType = eventData.crossSellType;
        }
        const decoratedProduct = this.decorateAdditionalDetails([product])[0];
        this.trolleyService.inMemoryStorage.setItem('addToCartEventData', eventData);
        return this.trolleyService.addOrUpdateTrolley(decoratedProduct, eventData.area);
    });

    publishEvent('removeCart', (product, eventData) => {
        const decoratedProduct = this.decorateAdditionalDetails([product])[0];
        this.trolleyService.inMemoryStorage.setItem('addToCartEventData', eventData);
        return this.trolleyService.removeTrolleyItem(decoratedProduct.Stockcode, decoratedProduct, eventData.area);
    });

    publishEvent('getCart', () => {
        return this.trolleyService.getTrolley();
    });

    publishEvent('openStockNearBy', (product) => {
        scope.closeStockNearByPopup = () => {
            scope.modalInstance.dismiss('cancel');
        };
        scope.product = this.decorateAdditionalDetails([product])[0];
        scope.modalInstance = this.$uibModal.open({
            animation: true,
            template: `
            <div class="modal-header">
                <div class="clearfix">
                    <span class="icon--crossmark pull-right icon--modal-close" ng-click="closeStockNearByPopup()"></span>
                </div>
            </div>
            <div class="modal-body">
                <div class="locator-search_loader" ng-if="::!product.Stockcode">
                    <wow-loading-spinner></wow-loading-spinner>
                </div>
                <stock-nearby-locator ng-class="{'modal-restricted-product' : false}" pack-size="product.ProductData.webpacktype" stock-code="::product.Stockcode" ng-if="::product.Stockcode"></stock-nearby-locator>
            </div>
            `,
            scope,
            size: 'lg',
            windowClass: 'modal--stock-nearby'
        });
    });


    this.$rootScope.$on('trolley:update', () => {
        trolleyListeners.forEach(listener => {
            // aem code can diff between available and unavailable using the individual product props
            listener({ AvailableItems: (this.trolleyService.trolleyProducts || [])
                        .concat(this.trolleyService.unavailableProducts || [])
                        .concat(this.trolleyService.restrictedProducts || [])
            });
        });
    });

    this.$rootScope.$on('logout:start', function () {
        sessionStorage.removeItem('shopperUpdated');
    });
};

AemPortalService.prototype.getRestHost = function () {
    const isProdhosts = [
        'https://bws.com.au', 'https://egbwsprdui-stage.azurewebsites.net', 'https://preprod.bws.com.au'
    ].some(item => window.location.origin === item);
    const isStagehosts = [
        'https://story-cellars.uat.bws.com.au',
        'https://uat.bws.com.au'
    ].some(item => window.location.origin === item);
    return isProdhosts ? 'https://aem.bws.com.au' : (isStagehosts ? 'https://aem-stage.bws.com.au' : 'https://aem-dev.bws.com.au');
};

module.exports = AemPortalService;


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/aem/aem-portal-service.js
 **/